import { Breadcrumb, Card, Col, Row } from "antd";
import { useDispatch } from "react-redux";
import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";

import UserInfo from "../components/user-account-info/UserInfo";
import Usage from "../components/user-account-info/Usage";
import UserInfoContent from "../components/user-account-info/UserInfoContent";
import { AuthContext } from "../context/AuthContext";
import { getUserInfo } from "../utils/utils";
import {
  getLeadCount,
  getUsageDetails,
} from "../actionCreator/commonActionCreator";
import { getToken } from "../utils/auth";

const MyAccount = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);
  const { id, account } = getUserInfo();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUsageDetails(getToken(), account?.id));
      dispatch(getLeadCount(getToken(), id));
    }
  }, [id, dispatch, isAuthenticated, account]);

  return (
    <div className="p-20">
      <Breadcrumb
        items={[
          {
            title: <Link to="/dashboard-view">Home</Link>,
          },
          {
            title: "My Account",
          },
        ]}
      />

      <Row gutter={[24, 24]} className="mt20">
        <Col xs={24} xl={17}>
          <UserInfo />
          <Card className="mt30">
            <UserInfoContent />
          </Card>
        </Col>
        <Col xs={24} xl={7}>
          <Usage />
        </Col>
      </Row>
    </div>
  );
};

export default MyAccount;
